import React from 'react'
import { useTranslation } from 'react-i18next'

import { Container, Body } from './styles'

import Loading from '../../components/Loading'
import Header from '../../components/Header'

import Footer from '../../components/Footer'

import challenge from './img/challenge.png'
import desktop from './img/desktop.png'
import mobile from './img/mobile.png'
import { ResultsDesktop, ResultsMobile } from '../../components/Results'

const CaseMobly: React.FC = () => {
  const { t, ready } = useTranslation(['case-mobly'])

  return (
    <Loading isLoading={!ready}>
      <Container>
        <Header />
        <Body>
          <section className="headline-section">
            <div>
              <h1>{t('headline.title')}</h1>
              <span>{t('headline.description')}</span>
            </div>
          </section>
          <section className="section section-left">
            <div className="left">
              <h1>{t('challenge.title')}</h1>
              <span>{t('challenge.description')}</span>
            </div>
            <div>
              <img src={challenge} alt={t('challenge.title')} />
            </div>
          </section>
          <section className="section section-right">
            <div className="mobile-hidden">
              <img src={desktop} alt={t('desktop.title')} />
            </div>
            <div className="right">
              <h1>{t('desktop.title')}</h1>
              <span>{t('desktop.description')}</span>
              <ResultsDesktop />
            </div>
          </section>
          <section className="section section-left">
            <div className="left">
              <h1>{t('mobile.title')}</h1>
              <span>{t('mobile.description')}</span>
              <ResultsMobile />
            </div>
            <div className="mobile-hidden">
              <img src={mobile} alt={t('mobile.title')} />
            </div>
          </section>
        </Body>
        <Footer />
      </Container>
    </Loading>
  )
}
export default CaseMobly
